<div class="w-full overflow-x-auto md:m-[0] sm:mt-[2rem]">
  <div class="w-full flex justify-center">
    <div class="w-[90%] flex justify-center mt-[2rem] sm:mt-[0%]">
      <div class="search-section items-center w-full flex flex-col justify-between md:flex-row">
        <div
          class="md:w-[30%] w-[95%]">
          <app-dropdown
            [parentFormGroup]="filterForm"
            [enableMultiple]="true"
            [enableClearSelection]="true"
            controlName="statuses"
            label="Status"
            placeholder="Select Status"
            [options]="statusOptions"
            type="small"
          ></app-dropdown>
        </div>
        <hr class="vertical hidden md:block">
        <div
          class="md:w-[40%] w-[95%]">
          <app-text-input
            (handleSuffixClick)="applyButtonClicked()"
            [parentFormGroup]="filterForm"
            [suffixIcon]="'search'"
            controlName="searchText"
            label="Search Questionnaire"
            placeholder="Search Questionnaire"
            type="small"
          ></app-text-input>
        </div>
        <hr class="vertical hidden md:block">
        <div
          class="filter-apply-button-wrapper w-full md:flex items-end justify-end md:w-[10%] md:mt-[1.5rem] mb-[1.5rem]">
          <app-primary-button
            (handleClick)="applyButtonClicked()"
            class="btn w-full"
            type="small">
            Apply
          </app-primary-button>
        </div>
      </div>
    </div>
  </div>
  <div class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
    <div
      class="table-section"
    >
      <mat-expansion-panel
        [expanded]="expandPanel"
        class="mat-elevation-z0 expansion-panel w-full"
      >
        <mat-expansion-panel-header
          class="bg-black-100 expansion-panel-header justify-center"
        >
          <div class="title">
            Questionnaires
          </div>
          <div *ngIf="!groupId && !clientId"
               class="sm:w-[40%] md:w-[26%] w-[40%] lg:w-[20%]">
            <app-primary-button
              (handleClick)="navigateToCreateSurvey()"
              class="w-full"
              type="small"
            >
              Add Questionnaires
            </app-primary-button>
          </div>
        </mat-expansion-panel-header>
        <div
          (scrolled)="getNext()"
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="10"
          [scrollWindow]="false"
          class="table-wrapper overflow-auto xs:h-[calc(100vh-35rem)] sm:h-[calc(100vh-30rem)] md:h-[calc(100vh-28rem)]"
          infiniteScroll
        >
          <table
            (matSortChange)="sortData($event)"
            [class.hidden]="loading && isFirstPage"
            [dataSource]="dataSource"
            mat-table
            matSort
          >
            <ng-container
              [sticky]="true"
              matColumnDef="title"
            >
              <th
                *matHeaderCellDef
                class="md:min-w-[35rem] min-w-[25rem] md:w-[35rem] w-[25rem]"
                mat-header-cell
                mat-sort-header
                id="title"
              >
                <div class="th-cell">
                  Title
                </div>
              </th>
              <td *matCellDef="let eachRow;let index=index"
                  mat-cell>
                <div class="td-cell">
                  <div class="survey-content">
                    {{ eachRow.title }}
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="createdAt"
            >
              <th
                *matHeaderCellDef
                class="min-w-[15rem] w-[15rem]"
                mat-header-cell
                mat-sort-header
                id="createdAt"
              >
                <div class="th-cell survey-title">
                  Created Date
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell survey-content">
                  {{ eachRow.createdAt | date }}
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="status"
            >
              <th
                *matHeaderCellDef
                class="min-w-[15rem] w-[15rem]"
                mat-header-cell
                mat-sort-header
                id="status"
              >
                <div class="th-cell survey-title">
                  Status
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell survey-content">
                  <div
                    [ngClass]="eachRow.status.value"></div>
                  {{ eachRow.status.value }}
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="view"
            >
              <th
                *matHeaderCellDef
                class="min-w-[10rem] w-[10rem]"
                mat-header-cell
                id="view"
              >
                <div class="th-cell survey-title">
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div
                  (click)="onClickViewSurveyDetails(eachRow)"
                  class="td-cell clickable survey-content survey-title">
                  {{
                  eachRow.status.key === 1 ? (!groupId && !clientId ? "Edit" : '') :
                    "View"
                  }}
                </div>
              </td>
            </ng-container>
            <ng-container
              *ngIf="!groupId && !clientId"
              matColumnDef="actions"
            >
              <th
                *matHeaderCellDef
                class="min-w-[5rem] w-[5rem]"
                mat-header-cell
              >
                <div class="th-cell survey-title">
                  <!--Status-->
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div
                  class="td-cell menu survey-content survey-title">
                  <button
                    [matMenuTriggerFor]="menu"
                    mat-icon-button
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button (click)="duplicateSurvey(eachRow)"
                            class="duplicate-menu-button"
                            mat-menu-item>Duplicate
                    </button>
                  </mat-menu>
                </div>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="surveyDisplayColumn; sticky: true;"
                mat-header-row></tr>
            <tr *matRowDef="let row; columns: surveyDisplayColumn;"
                mat-row></tr>
          </table>
          <div *ngIf="loading"
               [ngClass]="{ 'initial': !dataSource?.data?.length }"
               class="table-loader w-full flex justify-center items-center">
            <mat-spinner/>
          </div>
          <div
            *ngIf="!dataSource?.data?.length && !loading"
            class="no-data flex flex-col justify-center items-center"
          >
            <div class="text">
              No Data Found
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </div>
</div>
